import { Checkbox, Row, Col, Typography } from "antd";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

//redux
import { selectService } from "../../../../../store/service/service.action";

const { Text } = Typography;

const SelectService = ({ group, selected, setSelected, selectedService }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [data, setData] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const handleChange = (e) => {
    const service = e.target.value;
    const checked = e.target.checked;
    const name = group?.find((item) => item?.id === service).name;

    const data = {
      service,
      checked,
      name,
    };

    //Add new when selected dont have
    if (checked) {
      setSelected((selected) => {
        const newData = [...selected, data];
        selectService(dispatch, newData);
        return newData;
      });
    } else {
      const remove = selected?.filter((item) => item?.name !== name);
      setSelected(remove);
      selectService(dispatch, remove);
    }
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (group) {
      setData(group);
    }
  }, [group]);

  useEffect(() => {
    selectService(dispatch, selected);
  }, [selected, dispatch]);

  // -------------------------- RENDER --------------------------

  const renderItem = () => {
    const checked = selectedService?.map((row) => row.service);
    const newFormat = group?.map((item) => {
      const key = item?.id;
      const value = item?.id;
      const name = item?.name;

      return {
        key,
        value,
        name,
      };
    });
    return (
      <Checkbox.Group
        style={{ width: "100%", margin: "-1rem 0rem 0rem 1.5rem" }}
        value={checked}
      >
        {newFormat.map((item) => {
          return (
            <Col style={{ margin: "0.8rem 0rem" }} key={item?.key} span={24}>
              <Row className="checkbox-item">
                <Col span={2}>
                  <Checkbox
                    onChange={handleChange}
                    value={item?.value}
                    // checked={checked}
                  />
                </Col>
                <Col span={16}>
                  <Text style={{ width: "100%", flexWrap: "wrap" }}>
                    {item?.name} {item?.from ? "*" : null}
                  </Text>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Checkbox.Group>
    );
  };

  // -------------------------- MAIN --------------------------
  return <>{renderItem()}</>;
};

export default SelectService;
